import React, { FC, PropsWithChildren } from 'react';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd/dist/core/DndProvider';

import CustomDragLayer from './CustomDragLayer';

const Provider: FC<PropsWithChildren> = ({ children }) => (
  <DndProvider backend={HTML5Backend}>
    {children}
    <CustomDragLayer />
  </DndProvider>
);

export default Provider;
